// extracted by mini-css-extract-plugin
export var checkbox = "_80-0";
export var circle = "_80-3";
export var horizontalContainer = "_80-7";
export var sm = "_80-5";
export var switch0 = "_80-2";
export var switchDisabled = "_80-8";
export var switchEnabled = "_80-1";
export var textSwitchContainer = "_80-9";
export var textSwitchOption = "_80-a";
export var textSwitchOptionSelected = "_80-b";
export var verticalContainer = "_80-6";
export var xs = "_80-4";